import React, { useState } from "react"

import { NotificationManager } from "react-notifications"
import Select from "react-select"

import {
  findGeminiLanguage,
  geminiLanguageOptions,
} from "src/geminiLanguageOptions"

import { gql, useMutation } from "hooks/urql"

type SetTranslationLanguageProps = {
  studentId: string
  currentLanguageCode: string
  disabled: boolean
}

const SetTranslationLanguage: React.FC<SetTranslationLanguageProps> = ({
  studentId,
  currentLanguageCode,
  disabled,
}) => {
  const [, runMutation]: any[] = useMutation(updateLiveTranslationLanguage)
  const [selectedLanguageCode, setSelectedLanguageCode] =
    useState(currentLanguageCode)

  const handleSubmit = (newLanguageCode: string) => {
    setSelectedLanguageCode(newLanguageCode)
    runMutation({ studentId, languageCode: newLanguageCode })
      .then(result => {
        const { failures } =
          result.data.studentUpdateDefaultLiveTranslationLanguage
        if (failures.length > 0) {
          setSelectedLanguageCode(currentLanguageCode)
          NotificationManager.error(failures[0].message)
        } else {
          window.location.reload()
        }
      })
      .catch(() => {
        setSelectedLanguageCode(currentLanguageCode)
        NotificationManager.error("Something went wrong")
      })
  }

  return (
    <div className="form-group w-[250px]">
      <Select
        options={geminiLanguageOptions}
        value={findGeminiLanguage(selectedLanguageCode)}
        onChange={opt => handleSubmit(opt?.value)}
        isClearable
        isDisabled={disabled}
        menuPortalTarget={document.body}
      />
    </div>
  )
}

const updateLiveTranslationLanguage = gql`
  mutation ($studentId: ID!, $languageCode: String) {
    studentUpdateDefaultLiveTranslationLanguage(
      studentId: $studentId
      languageCode: $languageCode
    ) {
      failures {
        message
      }
    }
  }
`

export default SetTranslationLanguage
